// extracted by mini-css-extract-plugin
export default {"no-data":"NoDataFeedback_no-data__5qzTC","no-data-icon":"NoDataFeedback_no-data-icon__yrpU9","no-data-text":"NoDataFeedback_no-data-text__zSCt-"};